export default "__VITE_ASSET__7amESt9R__"